<template>
  <div>
    <Nav></Nav>
    <b-container>
      <b-row>
        <b-col>
          <h1 v-if="actualGroup.id > 0">
            Grupo:
            {{ this.actualGroup.id + " " + this.actualGroup.name }}
          </h1>
          <h1 v-else>Crear Grupo</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col md="6" sm="12">
                <b-form-group label="Nombre:">
                  <b-form-input
                    v-model="actualGroup.name"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6" sm="12">
                <b-form-group label="Nombre Boton:">
                  <b-form-input
                    v-model="actualGroup.button_text"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6" sm="12">
                <b-form-group label="Ordenacion:">
                  <b-form-input
                    v-model.number="actualGroup.ordenation"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6" sm="12">
                <b-form-group label="Activo:">
                  <b-form-checkbox v-model="actualGroup.status">
                    Activo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-button
                v-if="actualGroup.id > 0"
                block
                variant="success"
                @click="updateGroup"
                >Guardar</b-button
              >
              <b-button v-else block variant="success" @click="createGroup"
                >Crear</b-button
              >
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
export default {
  name: "Group",
  components: { Nav },
  data() {
    return {
      actualGroup: {
        id: 0,
        name: "",
        button_text: "",
        description: "",
        image: "",
        ordenation:0,
        status: false,
      },
    };
  },
  mounted() {
    if (this.$route.params.id > 0) {
      this.actualGroup.id = this.$route.params.id;
      console.log(this.actualGroup.id);
      this.getGroup();
    }
  },
  methods: {
    getGroup() {
      console.log(this.actualGroup);
      let that = this;
      axios
        .get("/group/" + this.actualGroup.id)
        .then(function (response) {
          that.actualGroup = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    updateGroup() {
      let that = this;
      axios
        .put("/group/" + this.actualGroup.id, this.actualGroup)
        .then(function (response) {
          that.actualGroup = response.data;
          that.makeToast("Exito", "exito al guardar", "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    createGroup() {
      let that = this;
      axios
        .post("/group", this.actualGroup)
        .then(function (response) {
          that.actualGroup = response.data;
          console.log(response.data)
          that.makeToast("Exito", "exito al crear", "success");
          that.$router.push("/group/" + response.data.id);
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
